<template>
	<div class="corporation">
		<div class="corporationCon">
			<searchBox :type='3' place='搜索公司' @search='search($event)'></searchBox>
			<div v-loading="loading">
				<div class="nodata" v-if="list.length==0">
					<no-Data></no-Data>
				</div>
				<div class="list">
					<div v-for="(item,index) of list" :key="index" class="li">
						<div class="top" @click="companyDe(item.id)">
							<el-image :src="item.logo||require('@/static/company.png')" fit="cover" class="logo"></el-image>
							<div class="name lineTextHidden">
								{{item.company_name}}
							</div>
							<div class="num">
								{{item.person_count}}
							</div>
						</div>
						<div v-if="item.position_one" class="bottom" @click="poDetails(item.position_one.id)">
							<div class="status">
								在招
							</div>
							<div class="name">
								{{item.position_one.position_name}}
							</div>
							<div class="pay" v-if="item.position_one.type=='2'">{{item.position_one.salary_part_time_job}}</div>
							<div class="pay" v-else>
								{{`${parseFloat((item.position_one.salary_min/1000).toFixed(1))}-${parseFloat((item.position_one.salary_max/1000).toFixed(1))}k`}}
							</div>
						</div>
						<div v-else class="bottom">
							暂无在招职位
						</div>
						<div v-else class="bottom" style="background-color: #Fff;"></div>
					</div>
				</div>
			</div>
			
			<div v-if="total>0" class="page">
				<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
					@current-change='changePage'>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import searchBox from '@/components/searchBox.vue'
	export default {
		name: 'corporation',
		components: {
			searchBox
		},
		data() {
			return {
				company_name:'',
				page: 1,
				total: 0,
				loading: false,
				list: [],
				limit: 12
			}
		},
		created() {
			this.getList()
		},
		methods: {
			poDetails(id){
				console.log(id)
				this.$router.push({ name: 'positionDe',query: {id:id } });
			},
			// 搜索
			search(value) {
				this.company_name = value
				this.page = 1
				this.getList()
			},
			getList() {
				this.loading = true
				let data = {
					page: this.page,
					company_name: this.company_name,
					limit: this.limit
				}
				this.$axios.get('/api/client/Home/getCompanyList', {
					params: data
				}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			companyDe(id){
				this.$router.push({ name: 'companyDe',query: {id:id } });
			},
		}
	}
</script>

<style lang="scss" scoped>
	.corporation {

		.corporationCon {
			padding: 48px 0;
			position: relative;
			z-index: 2;
			width: 1200px;
			margin: 0 auto;

			.page {
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 48px 0 0;
			}
			.nodata{
				height: 400px;
				background: #FFFF;
			}
			.list {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.li {
					background-color: #FFF;
					margin-right: 16px;
					margin-bottom: 16px;
					width: 288px;
					height: 269px;
					border-radius: 16px;
					display: flex;
					align-items: center;
					flex-direction: column;
					justify-content: space-between;
					cursor: pointer;
					&:nth-child(4n) {
						margin-right: 0;
					}

					.top {
						flex: 1;
						padding: 22px 0 18px;
						// display: flex;
						// align-items: center;
						// flex-direction: column;
						// justify-content: space-between;
						text-align: center;
						color: #151515;
						.logo {
							width: 86px;
							height: 86px;
							border-radius: 16px;
							margin-bottom: 10px;
						}

						.name {
							font-size: 17px;
							font-weight: bold;
							padding: 0 18px;
							height: 46px;
							box-sizing: border-box;
							text-align: center;
						}
						.num {
							margin-top: 8px;
							font-size: 14px;
						}
					}

					.bottom {
						height: 56px;
						background-color: rgba(155, 108, 255, 0.1);
						border-radius: 16px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						padding: 0 18px;
						box-sizing: border-box;
						font-size: 14px;
						width: 100%;
						.status {
							color: #151515;
							flex: 0 0 2em;
						}

						.name {
							color: #51A190;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							width: 134px;
						}

						.pay {
							max-width: 100px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}
				}
			}
		}

	}
</style>